import type {
  AiChatState,
  UiStreamAction,
  UiStreamHooks,
} from "@intelligems/ig-types";

import { AiChatStateProcessor } from "./processors/ai-chat-state-processor";
import { MessageStreamProcessor } from "./processors/message-stream-processor";
import { ToolProcessor } from "./processors/tool-processor";
import { getOrCreateTurnAndNode } from "./processors/utils";

export const aiChatsReducer = (
  draft: AiChatState,
  payload: UiStreamAction,
  hooks?: UiStreamHooks
) => {
  switch (payload.type) {
    case "initialize":
      AiChatStateProcessor.handleInitialize(draft, payload);
      break;

    case "setSessionId":
      draft.sessionId = payload.sessionId;
      break;

    case "reset":
      AiChatStateProcessor.handleReset(draft);
      break;

    case "startWorkflow":
      AiChatStateProcessor.handleStartWorkflow(draft, payload);
      break;

    case "addMessage":
      try {
        AiChatStateProcessor.handleAddMessage(draft, payload, hooks);
      } catch (e) {
        console.log(e);
        if (e instanceof Error && e.message?.includes("Cannot add property")) {
          // ignore
        } else {
          throw e;
        }
      }
      break;

    case "addMessageToLastNode":
      MessageStreamProcessor.handleAddMessageToLastNode(draft, payload);
      break;

    case "addStreamPart":
      MessageStreamProcessor.handleAddStreamPart(draft, payload, hooks);
      break;

    case "addToolProgress": {
      const { node } = getOrCreateTurnAndNode(draft, payload);
      ToolProcessor.handleToolProgress(node, payload);
      break;
    }

    case "setNextAction":
      MessageStreamProcessor.handleSetNextAction(draft, payload);
      break;

    case "setEventType":
      AiChatStateProcessor.handleSetEventType(draft, payload);
      break;

    case "updateMetadata":
      AiChatStateProcessor.handleUpdateMetadata(draft, payload);
      break;

    case "start":
      AiChatStateProcessor.handleStart(draft, payload);
      break;

    case "finish":
      AiChatStateProcessor.handleFinish(draft, payload);
      break;

    case "setError":
      AiChatStateProcessor.handleSetError(draft, payload);
      break;

    case "workflowPaused":
      draft.status = "paused";
      break;

    case "saveMessages":
    case "saveStream":
      // not sent to FE
      break;

    default: {
      // Exhaustive check - if this errors, we missed a case
      const exhaustiveCheck: never = payload;
      console.warn("Unhandled action type:", exhaustiveCheck);
      break;
    }
  }

  return draft;
};
